var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGuiasPraticosIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "guias-praticos-icon",
    transform: "translate(-20 -99)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28484",
    "data-name": "Rectangle 28484",
    width: 25,
    height: 25,
    transform: "translate(20 99)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "school_FILL0_wght400_GRAD0_opsz24",
    d: "M51.428-821.3l-7.272-3.948v-6.233L40-833.767,51.428-840l11.428,6.233v8.311H60.778v-7.168L58.7-831.481v6.233Zm0-8.623,7.116-3.844-7.116-3.844-7.116,3.844Zm0,6.259,5.194-2.8v-3.922l-5.194,2.857-5.194-2.857v3.922ZM51.428-829.923ZM51.428-827.585ZM51.428-827.585Z",
    transform: "translate(-18.979 942.2)",
    fill: "#0e426a"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuiasPraticosIcon);
export default __webpack_public_path__ + "static/media/guias-praticos-icon.be75f42d60795d4d778ffd9ae207ae72.svg";
export { ForwardRef as ReactComponent };